/* eslint-disable max-len */
import { ComponentPropsWithoutRef, memo } from 'react';

interface IArrowRightShortIcon extends ComponentPropsWithoutRef<'svg'> {
  fill?: string;
}

function ArrowRightShortIcon({
  fill = '#1D1D1D',
  ...props
}: IArrowRightShortIcon) {
  return (
    <svg
      width="33"
      height="33"
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="icons">
        <path
          id="Vector"
          d="M10.5 4.69531L22.5 16.6953L10.5 28.6953"
          stroke={fill}
          strokeWidth="4"
          strokeLinecap="square"
        />
      </g>
    </svg>
  );
}

export default memo(ArrowRightShortIcon);
